import { ReducerBuilder } from 'typescript-fsa-reducers';

import { applyAsyncReducer } from '@utils';

import { menuCatalogFetchList } from './menuCatalogFetchList';

import { IMenuCatalogStore } from '../../types';
import { IActionMenuCatalogFetchListPayloadDone } from './types';

export const menuCatalogFetchListReducer = (store: ReducerBuilder<IMenuCatalogStore, IMenuCatalogStore>) => {
	applyAsyncReducer<IMenuCatalogStore['items']['data'], IMenuCatalogStore['items']['meta']>()(
		'items',
		'networkStatus',
		menuCatalogFetchList.async,
		store,
		(props: { result: IActionMenuCatalogFetchListPayloadDone }) => ({
			list: props.result.items,
		}),
	);
};
